import React from 'react';
import { BusyIndicator, BusyIndicatorSize } from '@ui5/webcomponents-react';
import { useStyles } from './Loading.jss';

interface LoadingProps {
  size: BusyIndicatorSize;
  delay?: number;
}

export const Loading: React.FC<LoadingProps> = (props) => {
  const { size, delay } = props;
  const classes = useStyles();

  return (
    <div className={classes.backdrop} data-testid="loading-page">
      <BusyIndicator style={{ background: 'transparent' }} active size={size} delay={delay ?? 0} />
    </div>
  );
};
